import { useAuthState } from '@vis-auth/react';
import { AccountApi, Configuration, MyI9, MyI9Response } from 'eve-account-client';
import { useMemo } from 'react';

const useConfiguration = (): Configuration => {
  const { accessToken } = useAuthState();
  const EVE_ACCOUNT_URL = '/api/account';

  const configuration = useMemo(
    () =>
      new Configuration({
        basePath: EVE_ACCOUNT_URL,
        accessToken: accessToken ?? '',
      }),
    [accessToken, EVE_ACCOUNT_URL],
  );

  return configuration;
};

const useAccountApi = (): AccountApi => {
  const configuration = useConfiguration();
  const api = useMemo(() => new AccountApi(configuration), [configuration]);

  return api;
};

export const updateAccountMyI9 = ({
  accountId,
  myI9,
  api,
}: {
  accountId: string;
  myI9: MyI9;
  api: AccountApi;
}): Promise<MyI9Response> => {
  return api.updateMyI9({
    accountId,
    myI9,
  });
};

export default useAccountApi;
